<div class="card">
  <div class="card-header card-header-info">
    <h4 class="card-title">Technical Issues Detected</h4>
    <p class="card-category">Showing audits with priority issues</p>
  </div>
  <div class="card-body">
    <div class="row mb-3">
      <div class="col-md-12">
        <div class="btn-group btn-group-sm">
          <button type="button" class="btn btn-filter" [ngClass]="priority === '' ? 'btn-info' : 'btn-outline-info'" (click)="setPriority('')">All</button>
          <button type="button" class="btn btn-filter" [ngClass]="priority === 'P0' ? 'btn-danger' : 'btn-outline-danger'" (click)="setPriority('P0')">P0 - Critical</button>
          <button type="button" class="btn btn-filter" [ngClass]="priority === 'P1' ? 'btn-warning' : 'btn-outline-warning'" (click)="setPriority('P1')">P1 - Warning</button>
          <button type="button" class="btn btn-filter" [ngClass]="priority === 'P2' ? 'btn-info' : 'btn-outline-info'" (click)="setPriority('P2')">P2 - Info</button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-hover">
        <thead class="text-primary">
          <th>URL</th>
          <th class="text-center">Score</th>
          <th>Top Issue</th>
          <th class="text-center">Priority</th>
          <th>Last Check</th>
          <th class="text-right">Actions</th>
        </thead>
        <tbody>
          <tr *ngFor="let audit of audits" (click)="selectAudit(audit)" style="cursor: pointer;">
            <td>
              <div class="text-truncate" style="max-width: 250px;" [title]="audit.url">
                {{ audit.urlPath || audit.url }}
              </div>
            </td>
            <td class="text-center font-weight-bold" [ngClass]="getScoreColor(audit.healthScore)">
              {{ audit.healthScore }}
            </td>
            <td>
              <span *ngIf="audit.issuesDetected?.length > 0">
                {{ audit.issuesDetected[0].problem }}
              </span>
              <span *ngIf="!audit.issuesDetected || audit.issuesDetected.length === 0" class="text-muted small">
                No issues
              </span>
            </td>
            <td class="text-center">
              <span class="badge" [ngClass]="getPriorityBadgeClass(audit.issuesDetected?.[0]?.priority)">
                {{ audit.issuesDetected?.[0]?.priority || '-' }}
              </span>
            </td>
            <td>{{ audit.checkedAt | date:'short' }}</td>
            <td class="text-right">
              <button class="btn btn-link btn-info btn-just-icon" (click)="$event.stopPropagation(); selectAudit(audit)">
                <i class="material-icons">visibility</i>
              </button>
            </td>
          </tr>
          <tr *ngIf="audits.length === 0 && !loading">
            <td colspan="6" class="text-center py-4 text-muted">No issues found with the current filters</td>
          </tr>
          <tr *ngIf="loading">
            <td colspan="6" class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
